import axios from 'axios';
import ENDPOINTS from 'tradera-constants/endpoints';
import {
    utilizeCancelToken,
    finalizeResponse,
    handleError
} from 'tradera-utils/api';
import cookieUtil from 'tradera-utils/cookie';
import { FORCE_GEO_DEV } from 'tradera-constants/cookies';
import { isServer } from 'tradera-utils/nextjs';

export const fetchGeolocation = () => {
    if (isServer) {
        return Promise.reject(
            'Cannot fetch geo information from server as that would give the wrong result.'
        );
    }

    const { cancel, cancelToken } = utilizeCancelToken('fetchGeolocation');

    if (cancel) cancel();

    const search = (window && window.location && window.location.search) || '';
    return axios
        .get(getGeoPublicApiUrl(search), {
            cancelToken
        })
        .then(finalizeResponse())
        .catch(handleError());
};

export const getGeoPublicApiUrl = search => {
    const match = search.match(/force-geo-(.*?)-dev/);

    if (match) {
        cookieUtil.createCookie(FORCE_GEO_DEV, match[1]);
        return `${ENDPOINTS.GEO_PUBLIC_API_URL}/${match[1]}`;
    }

    const forceGeoDevCookie = cookieUtil.readCookie(FORCE_GEO_DEV);
    if (forceGeoDevCookie) {
        return `${ENDPOINTS.GEO_PUBLIC_API_URL}/${forceGeoDevCookie}`;
    }

    return ENDPOINTS.GEO_PUBLIC_API_URL;
};
